import { render, staticRenderFns } from "./BasicIndex.vue?vue&type=template&id=3cbd3b31&scoped=true"
import script from "./BasicIndex.vue?vue&type=script&lang=js"
export * from "./BasicIndex.vue?vue&type=script&lang=js"
import style0 from "./BasicIndex.vue?vue&type=style&index=0&id=3cbd3b31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbd3b31",
  null
  
)

export default component.exports